import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-text-input',
  templateUrl: './select-text-input.component.html',
  styleUrls: ['./select-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectTextInputComponent),
      multi: true
    }
  ]
})
export class SelectTextInputComponent implements OnInit, ControlValueAccessor {
  @Input() prefix: string = '₹';
  @Input() readonly: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() invalidInput: any;
  @Input() placeHolder: any = "Enter amount";

  value: string = '';
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {}

  ngOnInit() {}

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    // Allow only digits and dot
    val = val.replace(/[^0-9.]/g, '');

    // Keep only first dot
    const firstDot = val.indexOf('.');
    if (firstDot !== -1) {
      const beforeDot = val.substring(0, firstDot + 1);
      const afterDot = val.substring(firstDot + 1).replace(/\./g, '');
      // Restrict to max 2 decimals
      val = beforeDot + afterDot.slice(0, 2);
    }

    this.value = val;
    input.value = val;
    this.onChange(this.value);
  }

  onBlur(): void {
    if (this.value) {
      const num = parseFloat(this.value);
      if (!isNaN(num)) {
        this.value = num.toFixed(2); // enforce 2 decimals
        this.onChange(this.value);
      } else {
        this.value = '';
        this.onChange(this.value);
      }
    }
  }
}
